import { FormControlLabel, Switch } from '@mui/material';
import axios from 'axios';
import Hashids from 'hashids';
import React, { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Card, Input, InputGroup } from 'reactstrap';

import Breadcrumb from '@/components/common/breadcrumb.component';
import Dropzone from '@/components/dropzone';
import ModalDialog from '@/components/modal-dialog';
import { Constants } from '@/constants';
import { getBrandById as getBrandByIdAction } from '@/redux/actions/brand.actions';

const hashids = new Hashids('', 12);

const BrandEditor = ({ BrandManager, getBrandById }) => {
  const location = useLocation();
  const params = useParams();

  const [hasId, setHasId] = useState(false);

  const [selectedName, setSelectedName] = useState<string | null>(null);
  const [selectedDescription, setSelectedDescription] = useState<string | null>(
    null
  );
  const [selectedWebsite, setSelectedWebsite] = useState<string | null>(null);
  const [selectedBlog, setSelectedBlog] = useState<string | null>(null);
  const [selectedPodcast, setSelectedPodcast] = useState<string | null>(null);
  const [selectedTwitterId, setSelectedTwitterId] = useState<string | null>(
    null
  );
  const [selectedInstagramId, setSelectedInstagramId] = useState<string | null>(
    null
  );
  const [selectedFacebookId, setSelectedFacebookId] = useState<string | null>(
    null
  );
  const [cigarBrand, setCigarBrand] = useState(true);

  const brandCoverImage = useRef(null);
  const brandLogoImage = useRef(null);

  const { brand: brandData } = BrandManager;

  const populateForm = (brandDetails) => {
    if (brandDetails) {
      setSelectedName(brandDetails.name);
      setSelectedDescription(brandDetails.description ?? null);
      setSelectedWebsite(brandDetails.website ?? null);
      setSelectedBlog(brandDetails.blog_url ?? null);
      setSelectedPodcast(brandDetails.podcast_url ?? null);
      setSelectedTwitterId(
        brandDetails.twitter_id ? `@${brandDetails.twitter_id}` : null
      );
      setSelectedInstagramId(
        brandDetails.instagram_id ? `@${brandDetails.instagram_id}` : null
      );
      setSelectedFacebookId(brandDetails.facebook_id ?? null);
      setCigarBrand(Boolean(brandDetails.cigar_brand));

      // TODO Populate the dropzones
    }
  };

  useEffect(() => {
    if (
      !location.state?.brand ||
      (params.id &&
        params.id !== location.state?.brand.hash_id &&
        params.id !== 'new')
    ) {
      getBrandById(hashids.decode(params.id));
    }
    setHasId(params.id !== 'new');
  }, [params.id]);

  useEffect(() => {
    if (location.state?.brand) {
      const { brand } = location.state;
      populateForm(brand);
    }
  }, [location.state?.brand]);

  useEffect(() => {
    if (brandData && brandData.id) {
      populateForm(brandData);
    } else {
      // TODO Clear the form?
    }
  }, [brandData]);

  const onFileDrop = (imageHolder) => (file) => {
    console.log('Received file for holder:', imageHolder);
    if (file) {
      console.log(file);
      console.log('Loading file...');
      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        console.log('Loaded file.');
        const dataUrl = event.target.result;
        console.log(dataUrl);
        // FIXME Implement these
        // setSelectedImageHolder(imageHolder);
        // setSelectedImageFile(dataUrl);
        // setShowMediaCropper(true);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const saveBrand = () => {
    const brand = {
      active: true,
      name: selectedName,
      description: selectedDescription,
      website: selectedWebsite,
      blog_url: selectedBlog,
      podcast_url: selectedPodcast,
      cigar_brand: cigarBrand,
      logo_image: brandLogoImage || undefined,
      cover_image: brandCoverImage || undefined,
      facebook_id: selectedFacebookId,
      instagram_id: selectedInstagramId && selectedInstagramId.replace('@', ''),
      twitter_id: selectedTwitterId && selectedTwitterId.replace('@', ''),
    };
    console.log(brand);
    if (hasId) {
      axios
        .put(`${Constants.apiPath}/brands/${hashids.decode(params.id)}`, brand)
        .then((result) => {
          // TODO Update details here?
        })
        .catch((err) => {
          console.log(err);
          // ErrorLogger.captureException(err);
        });
    } else {
      axios
        .post(`${Constants.apiPath}/brands`, brand)
        .then(() => {
          // TODO Update details here?
        })
        .catch((err) => {
          console.log(err);
          // ErrorLogger.captureException(err);
        });
    }
  };

  return (
    <>
      <Breadcrumb
        title={selectedName || 'Add New Brand'}
        label="Editor"
        parent="Brands"
        // badge={getBadgeTitle()}
        // badgeColor={getBadgeColor()}
        onBadgeClick={() => {
          alert('Coming soon!');
          // TODO This is going to allow them to toggle the active state
        }}
      />

      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }} />
        <button
          className="btn btn-primary btn-sm"
          onClick={saveBrand}
          style={isMobile ? { padding: '6px 14px' } : {}}
        >
          {isMobile ? <i className="icon icon-plus" /> : 'Save'}
        </button>
      </div>

      <div
        className="brand-editor row"
        style={{ maxWidth: 1200, margin: '24px auto' }}
      >
        <Card style={{ padding: 10 }}>
          <div
            style={{
              display: 'flex',
              marginBottom: 10,
              marginRight: 0,
            }}
          >
            <div>
              <Dropzone
                hideIcon
                id="brandLogo"
                ref={brandLogoImage}
                files={[]}
                dropText="Drop logo here"
                style={{
                  height: 150,
                  width: 150,
                  padding: 0,
                  borderRadius: '50%',
                }}
                imagePreviewStyle={{
                  height: 146,
                  width: 146,
                  objectFit: 'contain',
                }}
                onDrop={onFileDrop('brandLogo')}
              />
            </div>
            <div style={{ flex: 1, marginLeft: 12 }}>
              <Dropzone
                hideIcon
                id="brandCoverImage"
                ref={brandCoverImage}
                files={[]}
                dropText="Drop cover image here"
                style={{ height: 150, width: '100%', padding: 0 }}
                imagePreviewStyle={{
                  height: 146,
                  width: 146,
                  objectFit: 'contain',
                }}
                onDrop={onFileDrop('brandCoverImage')}
              />
            </div>
          </div>
        </Card>
        <Card style={{ padding: 10, marginTop: 12 }}>
          <div
            className="row"
            style={{
              marginBottom: 10,
              marginLeft: -20,
              marginRight: 0,
            }}
          >
            <div className="col-md-9">
              <div style={{ marginLeft: 10 }}>
                <span style={{ fontWeight: 700 }}>Name</span>
                <div
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                >
                  <input
                    className="form-control"
                    type="text"
                    name="brand-name"
                    value={selectedName}
                    style={{ textTransform: 'capitalize', width: '100%' }}
                    onChange={(e) => setSelectedName(e.target.value)}
                    id="select-name"
                  />
                </div>
              </div>
              <div style={{ marginLeft: 10 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={cigarBrand}
                      onChange={(e) => {
                        console.log('Changed brand type state:');
                        console.log(e.target);
                        console.log(
                          e.target.checked ? 'Switch is on' : 'Switch is off'
                        );
                        setCigarBrand(e.target.checked);
                      }}
                      color="secondary"
                    />
                  }
                  label="Is Cigar Brand?"
                />
              </div>
            </div>
          </div>
          <span style={{ fontWeight: 700 }}>Description</span>
          <div
            style={{
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <textarea
              className="form-control"
              name="brand-description"
              value={selectedDescription}
              onChange={(e) => setSelectedDescription(e.target.value)}
              id="select-description"
            />
          </div>
        </Card>
        <Card style={{ padding: 10, marginTop: 12 }}>
          <div className="row" style={{ marginTop: 10 }}>
            <div className="col-md-12">
              Website
              <Input
                className="form-control"
                type="text"
                name="website"
                value={selectedWebsite}
                onChange={(e) => setSelectedWebsite(e.target.value)}
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <div className="col-md-12">
              Blog RSS Feed
              <Input
                className="form-control"
                type="text"
                name="blogrss"
                placeholder="Ex.: https://example.com/wp-json/wp/v2/posts"
                value={selectedBlog}
                onChange={(e) => setSelectedBlog(e.target.value)}
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <div className="col-md-12">
              Podcast RSS Feed
              <Input
                className="form-control"
                type="text"
                name="podcastrss"
                placeholder="Ex.: https://mypodcast.libsynpro.com/rss"
                value={selectedPodcast}
                onChange={(e) => setSelectedPodcast(e.target.value)}
              />
            </div>
          </div>
        </Card>
        <Card style={{ padding: 10, marginTop: 12 }}>
          <div className="row" style={{ marginTop: 10 }}>
            <div className="col-md-4">
              Twitter
              <InputGroup>
                {/* <InputGroupAddon addonType="prepend"> */}
                {/*  <InputGroupText>@</InputGroupText> */}
                {/* </InputGroupAddon> */}
                <Input
                  className="form-control"
                  type="text"
                  name="twitterId"
                  value={selectedTwitterId}
                  placeholder="<username>"
                  onChange={(e) => setSelectedTwitterId(e.target.value)}
                />
              </InputGroup>
            </div>
            <div className="col-md-4">
              Facebook
              <InputGroup>
                {/* <InputGroupAddon addonType="prepend"> */}
                {/*  <InputGroupText>fb.com/</InputGroupText> */}
                {/* </InputGroupAddon> */}
                <Input
                  className="form-control"
                  type="text"
                  name="facebookId"
                  value={selectedFacebookId}
                  placeholder="<username>"
                  onChange={(e) => setSelectedFacebookId(e.target.value)}
                />
              </InputGroup>
            </div>
            <div className="col-md-4">
              Instagram
              <InputGroup>
                {/* <InputGroupAddon addonType="prepend"> */}
                {/*  <InputGroupText>@</InputGroupText> */}
                {/* </InputGroupAddon> */}
                <Input
                  className="form-control"
                  type="text"
                  name="instagramId"
                  value={selectedInstagramId}
                  placeholder="<username>"
                  onChange={(e) => setSelectedInstagramId(e.target.value)}
                />
              </InputGroup>
            </div>
          </div>
        </Card>
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }} />
        {hasId && (
          <>
            <button
              id="merge"
              style={{ marginRight: 10 }}
              type="button"
              className="btn btn-light btn-sm"
              // onClick={() => setShowMergeModal(true)}
            >
              {'Merge'}
            </button>
            {cigarBrand && (
              <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  ModalDialog.show({
                    type: 'warning',
                    title: 'Delete Brand?',
                    message: 'This will delete the brand and cannot be undone.',
                    buttons: [
                      {
                        label: 'No, Cancel',
                        onClick: () => {
                          ModalDialog.close();
                        },
                      },
                      {
                        label: 'Yes, Delete',
                        color: 'danger',
                        onClick: () => {
                          // deleteCigar();
                          alert('Coming back soon!');
                        },
                      },
                    ],
                  });
                }}
                style={
                  isMobile
                    ? { padding: '6px 14px', marginRight: 10 }
                    : { marginRight: 10 }
                }
              >
                {isMobile ? <i className="icon icon-trash" /> : 'Delete'}
              </button>
            )}
          </>
        )}
        <button
          className="btn btn-primary btn-sm"
          onClick={saveBrand}
          style={isMobile ? { padding: '6px 14px' } : {}}
        >
          {isMobile ? <i className="icon icon-plus" /> : 'Save'}
        </button>
      </div>
    </>
  );
};

const mapStateToProps = ({ BrandManager }) => ({ BrandManager });

export default connect(mapStateToProps, { getBrandById: getBrandByIdAction })(BrandEditor);
